import React from 'react';
import { Tooltip } from 'reactstrap';

export default class MultiLineSelect extends React.Component {
    constructor(props) {
        super(props);
        this.toggleToolTip = this.toggleToolTip.bind(this);
        this.validateOnBlur = this.validateOnBlur.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.state = {
            tooltipOpen: false,
            invalidInput: false,
            isSelectCustomized: false,
            showList: false,
            selectedIndex: 0
        };
    }

    componentDidMount() {
        this._isMounted = true;
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate(prevProps) {
        const { options, value, id } = this.props;
        let visitId = value && value.length > 0 ? value.split("|")[0] : "";
        if (prevProps.value !== value) this.isOptionsLoad = false;//allow incase the selected value is changed after default value.
        if (!this.isOptionsLoad && options && options.length > 0) {
            this.isOptionsLoad = true;
            if (id === "schedule-location" || id === "schedule-visit-type") {
                options.map((opt, index) => {
                    let deptId = opt.value && opt.value.length > 0 ? opt.value.split("|")[0] : "";
                    if (deptId !== "" && ((value.id && value.id === deptId) || (visitId !== "" && visitId === deptId))) {
                        this.setState({
                            selectedIndex: index
                        });
                        return;
                    }
                });
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            if (this._isMounted) {
                this.setState({
                    showList: false
                });
            }
        }
    }

    toggleToolTip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    onChange(event) {
        //TODO we need to add dynamic load.
        this.props.onChange(event, event.target.value);
        this.validateOnBlur(event);
    }

    validateOnBlur(event) {
        if (this.props.required) {
            event.persist();
            if (event.target.value) {
                this.setState({ invalidInput: false });
            }
            else {
                this.setState({ invalidInput: true });
            }
        }
    }

    onSelect(event) {
        if (this._isMounted) {
            this.setState({
                showList: !this.state.showList
            });
        }
    }

    onKeyDown(event) {
        if (this._isMounted) {
            this.setState({
                showList: false
            });
        }
    }

    onClickItem(event, index, opt) {
        const { onChange } = this.props;
        if (this._isMounted) {
            this.setState({
                selectedIndex: index,
                showList: !this.state.showList
            });
            onChange(event, opt.value);
        }
    }

    render() {
        const { placeholder, name, id, autoFocus, disabled, value, options, className, inputErrorMsg, tooltipID, tooltipMsg, prependIcon, dontShowNotEmpty } = this.props;
        const { selectedIndex, showList } = this.state;
        var dynamicClass = className ? className : '';
        const containerClassName = (value && !dontShowNotEmpty ? " input-not-empty" : "") + (this.state.invalidInput ? " input-invalid" : "") + ((tooltipID && tooltipMsg) ? " input-append" : "");
        const hadOptions = (options && options.length > 0) ? true : false;
        let multiLineOptions = [];

        if (hadOptions) {
            multiLineOptions = options.map((opt, index) => {
                return <li key={index} className={(selectedIndex === index ? "same-as-selected" : "")} aria-selected={selectedIndex === index} onClick={e => this.onClickItem(e, index, opt)} value={opt.value} label={opt.label} label2={opt.label2} role="option" tabIndex="-1">
                    <span className="multilineselectOption-header">{opt.label}</span><br></br>
                    <span className="multilineselectOption-address">{opt.label2}</span>
                </li>;
            });
        }

        return (
            <div className={"il-group mulitline-select" + containerClassName} tabIndex="1" onKeyDown={e => this.onKeyDown(e)} ref={this.setWrapperRef}>
                <div className={"form-control select-selected " + (disabled ? "disabled" : "")} tabIndex="0" role="combobox" onClick={e => this.onSelect(e)} aria-haspopup="listbox" aria-expanded={(showList) ? true : false} aria-owns={"select-items-" + id} aria-labelledby={"selected-label-" + id}>
                    <div className="multiline-select-selection" id={"selected-label-" + id} role="textbox" aria-readonly="true">
                        <span className="hidden" aria-hidden="false">{placeholder}</span>
                        {hadOptions && <> <span className="multilineselectOption-header truncate">{options[selectedIndex].label}</span>
                            <span className="multilineselectOption-address truncate">{options[selectedIndex].label2}</span> </>}
                    </div>
                </div>
                {hadOptions && <div className="multiline-select-options-container">
                    <ul className={"select-items " + (showList ? "" : "select-hide")} role="listbox" id={"select-items-" + id}>
                        {multiLineOptions}
                    </ul>
                </div>
                }
                {(tooltipID && tooltipMsg) && <div className="input-icon-append ">
                    <span className="icon-info" id={tooltipID} />
                    <Tooltip placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={tooltipID} toggle={this.toggleToolTip}>
                        {tooltipMsg}
                    </Tooltip>
                </div>}
                <div className="il-label" aria-hidden="true">{prependIcon && <span className={prependIcon} />} {placeholder}</div>
                {inputErrorMsg && <div className="input-error-msg">{inputErrorMsg}</div>}
            </div>
        );
    }
}